// src/components/Header.js
import React, { useEffect, useState } from 'react';
import '../styles/header.css'
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.svg';
import profile from '../assets/images/profile.png';
import { logout } from '../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import Toastmessage from './Toast';
import { toggleSidebar } from '../features/auth/AuthSlice';
import { resetState } from '../features/auth/AuthSlice';
import {
    Badge, IconButton, Box,
    Typography,
    Popover,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    Button,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import { Bell, Sun, Moon, Lock } from 'react-feather';
import { useSelector } from 'react-redux';


const Header = () => {

    // State to track whether the dropdown is shown
    const [isDropdownVisible, setDropdownVisible] = useState(false)
    const [isExpanded, setIsExpanded] = useState(false);
    const dispatch = useDispatch();

    const [darkMode, setDarkMode] = useState(false);

    const Usermail = useSelector((state) => state.auth.useremail);
    const Username = useSelector((state) => state.auth.name);


    const [anchorEl, setAnchorEl] = useState(null);

    const notifications = [
        {
            id: 1,
            name: 'Josephine Thompson',
            message: 'commented on admin panel "Wow 😍! this admin looks good and awesome design"',
            avatar: '/path/to/avatar1.jpg', // Replace with actual path or URL
        },
        {
            id: 2,
            name: 'Donoghue Susan',
            message: 'Hi, How are you? What about our next meeting',
            avatar: null, // No avatar, use initials
        },
        {
            id: 3,
            name: 'Jacob Gines',
            message: 'Answered to your comment on the post',
            avatar: '/path/to/avatar3.jpg', // Replace with actual path or URL
        },
    ];

    useEffect(() => {
        dispatch(resetState()); // Collapse sidebar on first load
    }, [dispatch]);

    // Function to toggle the dropdown visibility
    const toggleDropdown = () => {
        setDropdownVisible(prevState => !prevState);
    };

    const onLogout = () => {
        dispatch(logout());
        localStorage.removeItem('token');
        const toast = Toastmessage('Logout successfull!', true)
    };

    const handleToggle = () => {

        dispatch(toggleSidebar());
    };

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'notification-popover' : undefined;

    // Toggle theme function
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        const savedTheme = localStorage.getItem('theme') || 'light';
        setTheme(savedTheme);
    }, []);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setDarkMode(!darkMode);
        const newTheme = !darkMode ? 'dark' : 'light';
        // document.body.classList.toggle('dark', !darkMode);
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };


    return (
        <header className="box-card custom-header nav-fixed">
            <nav className="topnav navbar navbar-expand shadow justify-content-between justify-content-sm-start navbar-light" id="sidenavAccordion">

                <button onClick={handleToggle} className="btn btn-icon togglebtn btn-transparent-dark order-1 order-lg-0 me-2 ms-lg-2 me-lg-0" id="sidebarToggle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg></button>

                <Link className="navbar-brand pe-3 ps-4 ps-lg-2" to='/home'><img src={logo} width={100} /></Link>

                <ul className="navbar-nav align-items-center ms-auto">
                    <li className="nav-item  me-1 me-lg-3">
                        <Box sx={{
                             backgroundColor: 'var(--icon-background)',
                            padding: '8px',
                            borderRadius: '100px'
                        }}
                            onClick={toggleTheme} style={{ cursor: 'pointer' }}>
                            {darkMode ? <Sun color={'var(--icon-color)'}/> : <Moon  />}
                        </Box>
                    </li>
                    <li className="nav-item  me-0 me-lg-2">
                        <Box>
                            <IconButton
                                aria-describedby={id}
                                color="inherit"
                                onClick={handleOpen}
                                sx={{
                                    backgroundColor: 'var(--icon-background)',
                                }}

                            >
                                <Badge
                                    variant={'dot'}
                                    sx={{
                                        '& .MuiBadge-dot': {
                                            top: '20%',
                                            right: '23%',
                                            backgroundColor: '#3570FF'
                                        },
                                    }}>
                                    <Bell color={'var(--icon-color)'} />
                                </Badge>
                            </IconButton>
                            <Popover
                                sx={{
                                    '& .MuiPaper-root': {
                                        boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;'

                                    },
                                }}
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <Box sx={{ width: 350, }}>
                                    <Box display={'flex'} px={3} py={2} justifyContent={"space-between"} alignItems={'center'}>
                                        <Typography variant="h6" gutterBottom m={0}>
                                            Notifications
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="primary"
                                            sx={{ textAlign: 'right', cursor: 'pointer', mb: 1 }}
                                            onClick={() => alert('Clear All Clicked')}
                                        >
                                            Clear All
                                        </Typography>
                                    </Box>
                                    <Divider variant="middle" />
                                    <List>
                                        {notifications.map((notification) => (
                                            <ListItem key={notification.id} p={3} alignItems="flex-start">
                                                <ListItemAvatar>
                                                    {notification.avatar ? (
                                                        <Avatar src={notification.avatar} />
                                                    ) : (
                                                        <Avatar>{notification.name.charAt(0)}</Avatar>
                                                    )}
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={notification.name}
                                                    secondary={notification.message}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                    <Box sx={{ textAlign: 'center', my: 2 }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            sx={{
                                                backgroundColor: '#F3F4FC',
                                                color: "#3570FF",
                                                fontWeight: 'bold',
                                                border: 'none',
                                                padding: '10px 20px',
                                                boxShadow: 'none'
                                            }}
                                            onClick={() => alert('View All Notifications Clicked')}
                                        >
                                            View All Notifications
                                        </Button>
                                    </Box>
                                </Box>
                            </Popover>
                        </Box>

                    </li>
                    <li className="nav-item dropdown no-caret dropdown-user me-0 me-lg-4">
                        <a  className={`btn btn-icon btn-transparent-dark ${isDropdownVisible ? 'show' : ' '}`} id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={toggleDropdown}>
                            <h6 className="dropdown-header d-flex align-items-center gap-3">
                                <img className="dropdown-user-img" src={profile} />
                                <div className="dropdown-user-details">
                                    <div className="dropdown-user-details-name text-start">{Username}</div>
                                    {/* <div className="dropdown-user-details-email">{Usermail}</div> */}
                                </div>
                            </h6>
                        </a>
                        <div className={`dropdown-menu dropdown-menu-end border-0 shadow animated--fade-in-up end-0  ${isDropdownVisible ? 'show' : ' '}`} aria-labelledby="navbarDropdownUserImage">
                            {/* <h6 className="dropdown-header d-flex align-items-center gap-3">
                                <img className="dropdown-user-img" src={profile} />
                                <div className="dropdown-user-details">
                                    <div className="dropdown-user-details-name">Valerie Luna</div>
                                    <div className="dropdown-user-details-email">vluna@aol.com</div>
                                </div>
                            </h6> */}
                            {/* <div className="dropdown-divider"></div> */}
                            <Link to='/changepassword' className="dropdown-item">
                                <div className="dropdown-item-icon">
                                    <Lock size={'13px'} color={'var(--table-icon-bg)'} />
                                </div>
                                Change Password
                            </Link>
                            <a className="dropdown-item" onClick={onLogout}>
                                <div className="dropdown-item-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" strokeLinejoin="round" className="feather feather-log-out"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></div>
                                Logout
                            </a>

                        </div>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
